import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const iconSx = { color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" };

const ContactIcon = ({ type }) =>
  type === "phone" ? <PhoneIcon sx={iconSx} /> : <EmailIcon sx={iconSx} />;

export default ContactIcon;
